import { flow } from 'lodash';

import { NAME } from './cb.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
